(() => {
  if (window.__addOnQtySync) return;
  window.__addOnQtySync = true;

  const CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const DEBOUNCE_MS = 500;

  let timeoutId = null;
  let selfRequest = false;

  function isCartMutation(url) {
    if (!url) return false;
    try {
      return CART_MUTATION.test(String(url));
    } catch (e) {
      return false;
    }
  }

  function getQuantityUpdates(cart) {
    if (!cart || !cart.items) return {};

    const mainItemsByKey = {};
    cart.items.forEach((item) => {
      const mainKey = item.properties && item.properties['_po:mainItemKey'];
      if (mainKey) mainItemsByKey[mainKey] = item;
    });

    const updates = {};
    cart.items.forEach((item) => {
      const parentKey = item.properties && item.properties['_po:addOnParentLineKey'];
      if (!parentKey) return;
      const mainItem = mainItemsByKey[parentKey];
      if (!mainItem) return;
      const qtyPerMainUnit = parseInt(item.properties['_po:addOnQty'], 10) || 1;
      const expectedQuantity = mainItem.quantity * qtyPerMainUnit;
      if (item.quantity !== expectedQuantity) updates[item.key] = expectedQuantity;
    });
    return updates;
  }

  function refreshCartUI(state) {
    if (state && state.sections && state.sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        const parsed = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html');
        const source = parsed.querySelector('.shopify-section');
        const target = bubble.querySelector('.shopify-section') || bubble;
        if (source) target.innerHTML = source.innerHTML;
      }
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'addon-qty-sync', cartData: state });
    }
  }

  function runSync() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        const updates = getQuantityUpdates(cart);
        if (Object.keys(updates).length === 0) return;

        selfRequest = true;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates, sections: ['cart-icon-bubble'] }),
        })
          .then((response) => (response.ok ? response.json() : null))
          .then((state) => {
            if (state) refreshCartUI(state);
          })
          .finally(() => {
            selfRequest = false;
          });
      })
      .catch((e) => {
        console.error('[addon-qty-sync]', e);
      });
  }

  function scheduleSync() {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(runSync, DEBOUNCE_MS);
  }

  window.AddOnQtySync = { schedule: scheduleSync, run: runSync };

  const nativeOpen = XMLHttpRequest.prototype.open;
  const nativeSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__addOnSyncWatch = String(method || '').toUpperCase() === 'POST' && isCartMutation(url);
    return nativeOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__addOnSyncWatch) {
      this.addEventListener('load', () => {
        if (this.status < 400) scheduleSync();
      });
    }
    return nativeSend.apply(this, arguments);
  };

  const nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : input && input.url;
      const method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      const watch = !selfRequest && method === 'POST' && isCartMutation(url);

      const result = nativeFetch.apply(this, arguments);
      if (!watch) return result;

      return result.then((response) => {
        if (response.ok) scheduleSync();
        return response;
      });
    };
  }
})();
